import { createSlice } from '@reduxjs/toolkit';
import { HttpRequestType } from '../../adapters/xhr/RequestStatus';

import { ApiURLs, API_BASE_URL } from '../../common/url';

import { AsyncThunkAction } from '../asyncThunk';

const initialState = {
  roles: [],
}

export const getRolesData = AsyncThunkAction('data/activeRoles', API_BASE_URL + ApiURLs.Roles.getRoles)
export const getAssignedUserCount = AsyncThunkAction('data/assignedUserCount', API_BASE_URL + ApiURLs.Roles.getAssignedUserCount, HttpRequestType.POST)

const rolesSlice = createSlice({
  name: 'activeRoles',
  initialState: initialState,
  reducers: {
  }
})
export default rolesSlice;